import { ChangeDetectionStrategy, Component, inject, input, output, signal, viewChild } from '@angular/core';
import { UserSearchTitleComponent } from '../user-search-title/user-search-title.component';
import { UserSearchBarComponent } from '../user-search-bar/user-search-bar.component';
import { UserSearchTextConfig } from './user-search.types';
import { ShSpinnerComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { GraphUser, GraphUserSearchQuery } from '@gbr-monorepo/interfaces';
import { GraphUserServiceContract } from '../../../user-management/users/services/graph-user-service.contract';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-user-search',
    templateUrl: 'user-search.component.html',
    imports: [UserSearchTitleComponent, UserSearchBarComponent, ShSpinnerComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSearchComponent {
    public readonly texts = input.required<UserSearchTextConfig>();

    private readonly directoryUserService = inject(GraphUserServiceContract);

    public readonly select = output<GraphUser>();

    protected readonly isLoading = signal(false);
    protected readonly hasError = signal(false);
    protected readonly results = signal<GraphUser[]>([]);

    private readonly searchBar = viewChild.required(UserSearchBarComponent);

    protected async onSearch(search: GraphUserSearchQuery | null): Promise<void> {
        if (!search) {
            this.results.set([]);
            return;
        }

        this.isLoading.set(true);
        this.hasError.set(false);

        const { items } = await firstValueFrom(this.directoryUserService.findUsers(search));

        try {
            this.results.set(items);
        } catch {
            this.hasError.set(true);
        } finally {
            this.isLoading.set(false);
        }
    }

    protected onSelect(person: GraphUser): void {
        if (!person) {
            return;
        }

        this.select.emit(person);
        this.searchBar().clearSearch();
        this.results.set([]);
    }
}
